<template>
  <div>
    <h1 class="settings-title">
      Webhook Logs
    </h1>
    <div class="table-tools d-flex align-items-center justify-content-between flex-column flex-md-row">
      <b-col
        md="6"
        sm="12"
        class="px-0">
        <button
          class="btn btn-main btn-round"
          :disabled="!webhookLogsLoaded"
          @click="loadWebhookLogs">Refresh</button>
      </b-col>
      <b-col
        md="6"
        sm="12"
        class="px-0">
        <DatePicker
          ref="dateRange"
          class="text-md-right text-sm-left"
          @datesChanged="filterDates"/>
      </b-col>
    </div>
    <b-table
      :fields="fields"
      :items="webhookLogs.data"
      show-empty
      responsive
      class="merchant-dashboard__table scroll-area-horizontal">

      <!-- Status code column -->
      <template v-slot:cell(response_status_code)="data">
        <span
          :class="getStatus(data.item.response_status_code)"
          class="tag-item">{{ data.item.response_status_code }}</span>
      </template>

      <!-- Date column -->
      <template v-slot:cell(created_at)="data">
        {{ data.item.created_at | date }}
      </template>

      <!-- Actions column -->
      <template v-slot:cell(actions)="data">
        <b-dropdown
          right
          no-flip
          no-caret
          class="actions">
          <!-- button -->
          <template v-slot:button-content>
            <icon name="ellipsis-h"/>
          </template>
          <!-- Items -->
          <b-dropdown-item @click="openWebhookLogModal(data.item)">
            Webhook Details
          </b-dropdown-item>
        </b-dropdown>
      </template>

      <!-- No data content -->
      <template v-slot:empty="">
        <div
          v-if="!webhookLogs.length && !webhookLogsLoaded"
          class="loader">
          <div class="loading-circle"/>
        </div>
      </template>
    </b-table>

    <div class="paging mb-5 clearfix">
      <p class="float-left pages">{{ webhookLogs.meta.current_page }} of {{ webhookLogs.meta.last_page }}</p>
      <button
        :disabled="page === webhookLogs.meta.last_page"
        class="btn btn-default btn-paging float-right"
        @click="nextPage">Next</button>
      <button
        :disabled="page === 1"
        class="btn btn-default btn-paging float-right"
        @click="previousPage">Back</button>
      <b-input
        v-model="webhookLogs.meta.current_page"
        :disabled="webhookLogs.meta.last_page === 1"
        type="number"
        min="1"
        class="page-input"
        placeholder="1"
        @change="changePage"/>
    </div>
    <WebhookLogModal
      ref="webhookLogModal"
      :logp="selectedLog"/>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import WebhookLogModal from './modals/WebhookLogModal';
import DatePicker from '../../../common/DatePicker';

export default {
  name: 'WebhookLogs',
  components: {
    DatePicker,
    WebhookLogModal,
  },
  data() {
    return {
      fields: [
        {
          key: 'endpoint_url',
          label: 'URL',
        },
        {
          key: 'response_status_code',
          label: 'Status Code',
        },
        {
          key: 'type',
          label: 'Webhook Type',
        },
        {
          key: 'created_at',
          label: 'Date',
        },
        {
          key: 'actions',
          class: 'text-right',
        },
      ],
      selectedLog: {},
      dateRange: {
        startDate: '',
        endDate: '',
      },
      page: 1,
      limit: 10,
    };
  },
  computed: {
    ...mapGetters({
      webhookLogs: 'webhook/webhookLogs',
      webhookLogsLoaded: 'webhook/webhookLogsLoaded',
    }),
  },
  mounted() {
    this.loadWebhookLogs();
  },
  methods: {
    ...mapActions({
      fetchWebhookLogs: 'webhook/fetchWebhookLogs',
    }),
    getStatus(statusCode) {
      const statusFirstNumber = statusCode.toString().charAt(0);

      switch (statusFirstNumber) {
        case '2': {
          return 'success';
        }
        case '3':
        case '4': {
          return 'warning';
        }
        case '5': {
          return 'danger';
        }
        default: {
          return 'warning';
        }
      }
    },
    filterDates(dates) {
      if (dates.length) {
        this.dateRange = {
          startDate: dates[0].unix(),
          endDate: dates[1].unix(),
        };
      } else {
        this.dateRange = {
          startDate: '',
          endDate: '',
        };
      }

      this.page = 1;
      this.loadWebhookLogs();
    },
    changePage(page) {
      page = parseInt(page, 10);
      if (page > this.webhookLogs.meta.last_page) {
        page = this.webhookLogs.meta.last_page;
      }
      if (!page || page < 1) {
        page = 1;
      }
      this.page = page;
      this.loadWebhookLogs();
    },
    nextPage() {
      if (this.page >= this.webhookLogs.meta.last_page) {
        return;
      }
      this.page += 1;
      this.loadWebhookLogs();
    },
    previousPage() {
      if (this.page === 1) {
        return;
      }
      this.page -= 1;
      this.loadWebhookLogs();
    },
    loadWebhookLogs() {
      this.selectedLog = {};
      this.fetchWebhookLogs({
        merchant_id: this.$route.params.merchant_id,
        data: {
          limit: this.limit,
          page: this.page,
          start_date: this.dateRange.startDate,
          end_date: this.dateRange.endDate,
        },
      });
    },
    openWebhookLogModal(webhookLog = {}) {
      this.selectedLog = webhookLog;
      this.$nextTick(() => {
        this.$refs.webhookLogModal.show();
      });
    },
  },
};
</script>
